/**
 * Salesforce BPR Problem & Solution Categories
 *
 * 10 problem categories plus 'uncategorized' (11 total).
 * 5 populated lab areas have rule menus (15 issues, 30 patterns).
 * 5 adjacent areas have no menu and produce custom options.
 */
export const SALESFORCE_BPR_CATEGORIES = [
    'foundation',
    'lead_to_opportunity',
    'forecasting',
    'quote_and_pricing',
    'billing',
    'data_and_org_health',
    'data_migration',
    'custom_development',
    'integrations',
    'post_go_live',
    'uncategorized',
];
export const SALESFORCE_BPR_MENU_CATEGORIES = [
    'lead_to_opportunity',
    'forecasting',
    'quote_and_pricing',
    'billing',
    'data_and_org_health',
];
export const SALESFORCE_BPR_CATEGORY_DEFS = {
    foundation: {
        key: 'foundation',
        title: 'Foundation & Core Setup',
        description: 'Company settings, fiscal years, currencies, profiles, roles, and core sharing architecture.',
        hasMenu: false,
        displayRank: 1,
    },
    lead_to_opportunity: {
        key: 'lead_to_opportunity',
        title: 'Lead to Opportunity',
        description: 'Lead capture, qualification, routing, duplicate rules, and conversion to account/contact/opportunity.',
        hasMenu: true,
        displayRank: 2,
    },
    forecasting: {
        key: 'forecasting',
        title: 'Pipeline & Forecasting',
        description: 'Sales stages, probability weighting, collaborative forecasting, quotas, and territory management.',
        hasMenu: true,
        displayRank: 3,
    },
    quote_and_pricing: {
        key: 'quote_and_pricing',
        title: 'Quote & Pricing',
        description: 'Product catalog, price books, quote generation, approval matrices, and discounting rules.',
        hasMenu: true,
        displayRank: 4,
    },
    billing: {
        key: 'billing',
        title: 'Billing & Invoicing',
        description: 'Order activation, invoice generation, payment schedules, and ERP sync handoff.',
        hasMenu: true,
        displayRank: 5,
    },
    data_and_org_health: {
        key: 'data_and_org_health',
        title: 'Data & Org Health',
        description: 'Technical debt, automation consolidation (Flow vs Apex), storage limits, and security health check.',
        hasMenu: true,
        displayRank: 6,
    },
    data_migration: {
        key: 'data_migration',
        title: 'Data Migration',
        description: 'Legacy data extraction, field mapping, data cleansing, historical records, and deduplication.',
        hasMenu: false,
        displayRank: 7,
    },
    custom_development: {
        key: 'custom_development',
        title: 'Custom Development',
        description: 'Apex triggers, Lightning Web Components (LWC), custom REST/SOAP APIs, and platform events.',
        hasMenu: false,
        displayRank: 8,
    },
    integrations: {
        key: 'integrations',
        title: 'Integrations & Middleware',
        description: 'ERP (NetSuite, SAP), marketing automation, data warehouse, and identity provider integrations.',
        hasMenu: false,
        displayRank: 9,
    },
    post_go_live: {
        key: 'post_go_live',
        title: 'Post Go-Live Support & Hypercare',
        description: 'End-user training, hypercare stabilization, transition to managed services, and ongoing enhancements.',
        hasMenu: false,
        displayRank: 10,
    },
    uncategorized: {
        key: 'uncategorized',
        title: 'Uncategorized Discovery Notes',
        description: 'Discovery items that require further scoping or cross-functional triage.',
        hasMenu: false,
        displayRank: 11,
    },
};
//# sourceMappingURL=salesforce-bpr-categories.js.map